"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _config_diseaseclass = require("@/api/config_diseaseclass");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultDiseaseClass = {
  id: '',
  class_name: ''
};
var _default = exports.default = {
  data: function data() {
    return {
      listLoading: true,
      tableData: [],
      diseaseclass: defaultDiseaseClass,
      dialogVisible: false,
      dialogType: 'new',
      viewDialog: false,
      dialogTransformLoading: false,
      transformData: {
        results: []
      },
      rule1: {
        class_name: [{
          max: 100,
          message: '输入长度不能超过100位'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    handleAdd: function handleAdd() {
      this.diseaseclass = Object.assign({}, defaultDiseaseClass);
      this.dialogType = 'new';
      this.dialogVisible = true;
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _config_diseaseclass.getDiseaseClassAll)().then(function (response) {
        _this.tableData = response.data;
        _this.listLoading = false;
      });
    },
    handleView: function handleView(scope) {
      var _this2 = this;
      this.viewDialog = true;
      this.dialogTransformLoading = true;
      (0, _config_diseaseclass.getDiseaseClassDoctor)(scope.row.id).then(function (response) {
        _this2.transformData.results = response.data;
        _this2.dialogTransformLoading = false;
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this3 = this;
      this.diseaseclass = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this4 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _config_diseaseclass.deleteDiseaseClass)(scope.row.id);
            case 2:
              // this.tableData.splice($index, 1)
              _this4.getList();
              _this4.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(form) {
        var _this5 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this5.dialogType === 'edit';
                  if (isEdit) {
                    (0, _config_diseaseclass.updateDiseaseClass)(_this5.diseaseclass.id, _this5.diseaseclass).then(function (res) {
                      _this5.dialogVisible = false;
                      _this5.getList();
                      _this5.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _config_diseaseclass.createDiseaseClass)(_this5.diseaseclass).then(function (res) {
                      _this5.dialogVisible = false;
                      _this5.getList();
                      _this5.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};